import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appBadge = { discountBadgePayload: '_discountBadgePayload' };
var _appBoxData = {
    reviews: '_appReviews',
    pricing: '_appPricing',
    appBadges: '_appBadge',
};
var _appGroup = { apps: '_appBoxData' };
var _appPricing = { label: '_pricingLabel' };
var _appReviews = { averageRating: 'DOUBLE' };
var _discountBadgePayload = { endDate: 'google.protobuf.Timestamp' };
var _dynamicSection = { appGroup: '_appGroup' };
var _getAppsByAppIdsRequest = {};
var _getAppsByAppIdsResponse = { apps: '_appBoxData' };
var _getDynamicSectionsRequest = {};
var _getDynamicSectionsResponse = { sections: '_dynamicSection' };
var _getTagSectionsRequest = {};
var _getTagSectionsResponse = { sections: '_tagSection' };
var _oneTimePriceLabelData = { price: 'DOUBLE' };
var _pricingLabel = {
    recurringPriceLabelData: '_recurringPriceLabelData',
    oneTimePriceLabelData: '_oneTimePriceLabelData',
};
var _recurringPriceLabelData = { price: 'DOUBLE' };
var _tagSection = { appGroup: '_appGroup' };
function resolveComWixAppmarketAppMarketClientAggregatorServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_serverless/app-market-client-aggregator-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function getDynamicSections(payload) {
    var _a = serializer(_getDynamicSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDynamicSectionsResponse, {
        _appBadge: _appBadge,
        _appBoxData: _appBoxData,
        _appGroup: _appGroup,
        _appPricing: _appPricing,
        _appReviews: _appReviews,
        _discountBadgePayload: _discountBadgePayload,
        _dynamicSection: _dynamicSection,
        _oneTimePriceLabelData: _oneTimePriceLabelData,
        _pricingLabel: _pricingLabel,
        _recurringPriceLabelData: _recurringPriceLabelData,
    }).fromJSON;
    function __getDynamicSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.app_market_client_aggregator',
            method: 'GET',
            methodFqn: 'com.wix.appmarket.AppMarketClientAggregatorService.GetDynamicSections',
            url: resolveComWixAppmarketAppMarketClientAggregatorServiceUrl({
                protoPath: '/v1/dynamic-sections/{placement}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDynamicSections.fromReq = fromReq;
    __getDynamicSections.__isAmbassador = true;
    return __getDynamicSections;
}
export function getTagSections(payload) {
    var _a = serializer(_getTagSectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTagSectionsResponse, {
        _appBadge: _appBadge,
        _appBoxData: _appBoxData,
        _appGroup: _appGroup,
        _appPricing: _appPricing,
        _appReviews: _appReviews,
        _discountBadgePayload: _discountBadgePayload,
        _oneTimePriceLabelData: _oneTimePriceLabelData,
        _pricingLabel: _pricingLabel,
        _recurringPriceLabelData: _recurringPriceLabelData,
        _tagSection: _tagSection,
    }).fromJSON;
    function __getTagSections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.app_market_client_aggregator',
            method: 'GET',
            methodFqn: 'com.wix.appmarket.AppMarketClientAggregatorService.GetTagSections',
            url: resolveComWixAppmarketAppMarketClientAggregatorServiceUrl({
                protoPath: '/v1/tag-sections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTagSections.fromReq = fromReq;
    __getTagSections.__isAmbassador = true;
    return __getTagSections;
}
export function getAppsByAppIds(payload) {
    var _a = serializer(_getAppsByAppIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppsByAppIdsResponse, {
        _appBadge: _appBadge,
        _appBoxData: _appBoxData,
        _appPricing: _appPricing,
        _appReviews: _appReviews,
        _discountBadgePayload: _discountBadgePayload,
        _oneTimePriceLabelData: _oneTimePriceLabelData,
        _pricingLabel: _pricingLabel,
        _recurringPriceLabelData: _recurringPriceLabelData,
    }).fromJSON;
    function __getAppsByAppIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.app_market_client_aggregator',
            method: 'GET',
            methodFqn: 'com.wix.appmarket.AppMarketClientAggregatorService.GetAppsByAppIds',
            url: resolveComWixAppmarketAppMarketClientAggregatorServiceUrl({
                protoPath: '/v1/apps',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAppsByAppIds.fromReq = fromReq;
    __getAppsByAppIds.__isAmbassador = true;
    return __getAppsByAppIds;
}
//# sourceMappingURL=http.impl.js.map